import store from '@/store'

export default function (name) {
  return store.getters['auth/privileges'].includes(name)
}
